import consumer from "./consumer";

export interface INotificationsChannelOptions {
  onConnected?: () => void;
  onDisconnected?: () => void;
  onRejected?: () => void;
  onReceived?: (data: object) => void;
}

export const NotificationsChannel = (
  options?: INotificationsChannelOptions,
) => {
  const { onConnected, onDisconnected, onRejected, onReceived } = options ?? {};
  return consumer.subscriptions.create(
    { channel: "NotificationsChannel" },
    {
      connected() {
        if (onConnected) onConnected();
      },
      disconnected() {
        if (onDisconnected) onDisconnected();
      },
      rejected() {
        if (onRejected) onRejected();
      },
      received(data: object) {
        if (onReceived) onReceived(data);
      },
    },
  );
};
